import { AbstractDocument, Timestampable, Untrackable } from '../../../abstract/Document';
import type { IPreferenceCakes } from './cakes.types';

@Timestampable
@Untrackable
export class PreferenceCakes extends AbstractDocument<IPreferenceCakes> {
  readonly collections = {};
}
